module.exports = __webpack_public_path__ + "static/assets/af503237f250eaab70eec701bc0c88b9.png";